// WizardSummariesList.jsx
import React, { useState, useEffect } from 'react';
import {
    Container,
    Grid,
    Card,
    CardContent,
    Typography,
    CircularProgress,
    Alert,
    Box,
    Chip,
    CardActionArea
} from '@mui/material';
import { Link } from 'react-router-dom';
import wizardApi from '../../../../service'; // Adjust import path as needed

const WizardSummariesList = () => {
    const [summaries, setSummaries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadSummaries = async () => {
            try {
                setLoading(true);
                // Fetch wizard summaries from the specified endpoint
                const data = await wizardApi.getWizardSummaries();
                setSummaries(data);
                setError(null);
            } catch (err) {
                console.error('Error loading wizard summaries:', err);
                setError('Failed to load forms. Please try again later.');
                setSummaries([]);
            } finally {
                setLoading(false);
            }
        };

        loadSummaries();
    }, []);

    if (loading) {
        return (
            <Container maxWidth="lg" sx={{ py: 8, textAlign: 'center' }}>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>Loading forms...</Typography>
            </Container>
        );
    }

    if (error) {
        return (
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Alert severity="error">{error}</Alert>
            </Container>
        );
    }

    if (summaries.length === 0) {
        return (
            <Container maxWidth="lg" sx={{ py: 8, textAlign: 'center' }}>
                <Typography variant="h6" color="textSecondary">
                    No forms available at the moment.
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    Check back later or contact the administrator.
                </Typography>
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4, fontWeight: 500 }}>
                Available Forms
            </Typography>

            <Grid container spacing={3}>
                {summaries.map((wizard) => (
                    <Grid item xs={12} sm={6} md={4} key={wizard.id}>
                        <Card
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: 6
                                }
                            }}
                        >
                            <CardActionArea
                                component={Link}
                                to={`/forms/active/${wizard.id}/${wizard.url.replace('/', '')}`}
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    textDecoration: 'none'
                                }}
                            >
                                <CardContent sx={{ flexGrow: 1, width: '100%' }}>
                                    <Typography
                                        variant="h6"
                                        component="h2"
                                        gutterBottom
                                        sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            color: 'primary.main'
                                        }}
                                    >
                                        {wizard.name || `Form ${wizard.id}`}
                                    </Typography>                                    
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default WizardSummariesList;